// If you want to use variables, they should not include white spaces inside like `{{var}}`
export default {
  common: {
    next: "次へ",
    back: "戻る",
    close: "閉じる",
    cancel: "キャンセル",
    submit: "送信",
    hide: "非表示にする",
    show: "表示する",
    publish: "商品を表示する",
    unpublish: "商品を隠す",
    done: "完了",
    ok: "OK",
    leave: "戻る",
    price: "金額",
    duration: "期間",
    stay: "キャンセル",
    product: "製品",
    yes: "YES",
    no: "NO",
    download: "ダウンロード",
    uploadError: "ファイルのサイズが10MB以下であることを確認して下さい",
    errorMessage: "エラーが発生しました。後ほどもう一度お試し頂くか、弊社までご連絡下さい。",
  },
  month: {
    January: "1月",
    February: "2月",
    March: "３月",
    April: "４月",
    May: "５月",
    June: "６月",
    July: "７月",
    August: "８月",
    September: "９月",
    October: "１０月",
    November: "１１月",
    December: "１２月",
  },
  label: {
    productName: "製品名",
    tradeTerm: "取引条件",
    port: "港",
    packaging: "梱包",
    shipmentMonth: "出荷月",
    currency: "通貨",
    unit: "単位",
  },
  marketProviders: {
    sourcesageTitle: "油, 油脂 & 界面活性剤の価格設定",
    sourcesageSubtitle: "油 & 脂肪, オレオケミカル, 界面活性剤",
    sourcesageBody: "パームオイル, PKO, 脂肪族アルコール, 脂肪酸, SLES, SLS...",
    emptyStateTitle: "新機能も続々登場！お楽しみに！",
    emptyStateBody: "マーケットプロバイダーを選択して、様々な製品価格を確認しましょう",
    othersTitle: "他のプロバイダー",
    othersSubtitle: "油 & 脂肪, オレオケミカル, 界面活性剤",
    othersBody: "食用油 & 脂肪, オレオケミカル, 界面活性剤, ペトロケミカル",
  },
  DataSearchPage: {
    banner: "https://s3-ap-southeast-1.amazonaws.com/sourcesage/images/data-upload/Banner.png",
    mine: "あなたのデータページ",
    public: "マーケット提供者を選択する",
    private: "プライベート回覧のみ可能",
    private_note: "(あなたは以下の価格リストをご覧いただけるよう招待されました。)",
    placeholder: "製品名を入力して今日の価格をチェックしましょう",
  },
  setPrice: {
    title: "価格の設定",
    sub: "一回のアクセスごとの、期間と値段を設定してください",
    text: "あなたのデータページ回覧でお客様からをチャージし",
    sub2: "無料お試し回数を設定してください",
    text2: "データページ回覧の無料お試し回数を設定して、新規顧客開拓につなげましょう!",
    credit: "USD", // needs s??? so I defined this here
    hours: "時間",
    visit: "回",
    warn: "*一度設定し直すと、新規・既存顧客も含め、次のアクセスから適用されます。",
    free: "いいえ、私のデータページは無料で公開します",
  },
  dataPageStepsModal: {
    title: "ステップ", // followed by 1, 2 or 3
    sub1: "製品リストを作成する",
    text1: "顧客向けにページを公表する前に、製品とその他詳細をアップロードしましょう",
    sub2: "製品価格をアップロードする",
    text2: "最新の価格をアップロードしましょう",
    sub3: "お客様のページアクセスでを稼ぎましょう",
    text3: "You can choose to charge each customer for each visit on SourceSage, and cash out the money from SourceSage platform",
  },
  dataList: {
    submit: "変更更新",
    subHeader: "価格レポート | 最新アップデート",
    tableHeader1: "製品 & 情報",
    tableHeader2: "価格",
    addProduct: "製品を追加する",
    successModalHeader: "価格がアップデートされました",
    errorModalHeader: "データ価格をアップデートできません",
    delivery: "デリバリー",
    spotPrice: "スポット価格",
    preview: "プレヴュー",
    previewError: "You can not see preview",
    last_update: "最新アップデート: {{date}}",
    public_view: "全体に公開",
    private_view: "プライベート公開限定",
    follower: "フォロワー",
    followers: "フォロワー",
    attachment: "ATTACHMENT",
    attach_last_update: "LAST UPDATE",
    action: "ACTION",
    remove: "REMOVE",
    rename: "RENAME",
    save: "SAVE",
    add_attachment: "ADD ATTACHMENTS +",
    update_attachment: "UPDATE ATTACHMENTS",
    max_files: "Maximum 3 pdf(s)",
    current_price: "Current Price"
  },
  dataEntry: {
    last_update: "最新のアップデートは {{date}}にされました",
    preview: "ライブプレビュー",
    update: "価格のアップデート",
    use_credit: "Pay Now",
    free: "無料アクセス",
    free_trial: "無料お試しを利用する",
    warn: "このチャンネルは、あなたの前回のアクセス以降アップデートされました。最新の価格などをご確認ください。",
    purchase: "ポイントを購入する",
    insufficient_title: "ポイントが足りません",
    insufficient_text: "このページを回覧するのに必要なポイントがありません。ポイントを購入してください。",
    payAccess: "{{hour}} 時間のアクセス分の {{credit}} USDを利用します",
    payAccessManager: "あなたのユーザーは {{credit}} USDを  {{hour}} 時間のアクセス分に利用します",
    freeAccess: "あなたは {{access}} 回、無料お試しをご利用いただけます",
  },
  dataView: {
    product: "製品情報",
    price: "価格",
    change: "変更",
    preview: {
      pre_public: "全体に公開",
      pre_private: "プライベート公開限定",
      public: "このページは全体に公開されます",
      private: "このページは、招待されたユーザーのみに公開されます",
      exit: "プレヴューを閉じる",
      price_report: "価格レポート | 最新のアップデート {{date}}",
    },
  },
  dataItem: {
    note: "*入力必須項目を入力してください。これらの情報については今後変更ができません。ご注意ください。",
    leave: "このページを離れますか？変更は保存されません。右上の完了ボタンをクリックしてください。 ",
    price: "価格",
    spot: "スポット価格 (到着まで通常３０日以内)",
    future: "未来価格 (到着まで通常３０日以上)",
    price_type: "価格タイプ",
    price_single: "価格",
    price_range: "価格帯",
    price_max: "最高価格",
    price_min: "最低価格",
    confirmDialog: {
      title: "本当に変更しますか？",
      next: "変更を保存する",
      visit_fee: "１アクセスにつきかかるコスト:",
      visit_fee_text: " {{hours}} 時間につき{{credit}} USD",
      free_trial: "初回利用ユーザー用無料トライアル回数:",
      free_trial_text: "{{visits}} 回",
      set_price: "アクセスにかかるコストを編集する",
    },
    placeholder: {
      productName: "パームオイル, C1214",
      price: "こちらに価格を入力",
      port: "ジャカルタ、クランなど",
      shipMonth: "出荷月を選択してください",
    },
  },
  shopUpload: {
    ProductStep1: "Step 01: 製品の詳細",
    SeriesStep1: "Step 01: シリーズの詳細",
    SeriesStep2: "Step 02: シリーズの表示",
    ProductStep2: "Step 02: 製品の表示",
    AddDisplayPic: "表示写真を追加",
    SeriesReady: "シリーズの準備が完了しました!",
    ProductReady: "製品の準備が完了しました!",
    SeriesReadyInfoText: "ユーザーがあなたのシリーズを購読できるようになりました。今後データをアップロードする際、製品をシリーズへタグ付けすることが可能です。",
    ProductReadyInfoText: '製品が公開されました!製品の説明文は変更可能です。 "セールスを見る"から、あなたの売り上げをご確認いただけます！',
    ProductPopupTitle: "購読ベースのシリーズをオファーできます！",
    ProductPopupBody: "複数のレポートをシリーズまたはパッケージとして、定期的にカスタマーへ配信できます。ユーザーへの配信頻度や購読費用については、あなたが決定できます。",
    UploadProductText: "PDFフォーマットで製品をアップロードする",
    UploadProductSizeLimit: "最大サイズ：10MB",
    UploadImage: "画像アップロード",
    UploadNewProduct: "新しい製品をアップロード",
    UploadProduct: "製品をアップロード",
    UploadPreview: "アップロードプレビュー",
    AddExistingProduct: "既存商品を追加",
    name: "製品名/サービス名",
    description: "説明文",
    tag: "製品ダグ",
    AddToSeries: "購読シリーズに追加 (オプショナル)",
    isThisforSale: "この製品は販売用ですか?",
    forSale: "販売用",
    notForSale: "無料",
    frequency: "頻度",
    price: "価格 (USD)",
    PreviewQn: "プレビューファイルをお持ちですか？",
    EditSeries: "シリーズを編集",
    EditProduct: "製品を編集",
    SaveSeries: "シリーズを保存",
    DeleteSeries: "シリーズを削除",
    SelectProducts: "既存の製品を選択",
    SelectedItems: "個の製品が選択されています",
    YourProduct: "あなたの製品*",
    DeleteConfirmSeries: "本当にこのシリーズを削除してよろしいですか?",
    DeleteConfirmProduct: "本当にこの製品を削除してよろしいですか?",
    DeleteSuccessSeries: "このシリーズを削除しました!",
    DeleteSuccessProduct: "You have successfully deleted your product!",
    EditSuccess: "このシリーズを保存しました!",
    AddProductSuccess: "製品を追加しました!",
    RemoveProduct: "削除",
    RemoveProductConfirm: "本当にこの製品を削除してよろしいですか?",
    SeePreview: "プレビューを見る",
    EditPage: "ページを編集",
    all: "全て",
    Leave: "このページを離れますか? 変更内容は保存されません。",
    PricePerYear: "年間額",
    CannotUndo: "復元できません",
    ChangeImage: "画像を変更",
    SaveProduct: "製品を保存",
    Replace: "場所を変更",
    DeleteProduct: "製品を削除",
    BuyProduct: " {{credit}} USDで購入",
    PurchaseSuccess: "あなたはこのアイテムを購入しました。購入完了メールが間も無くあなたのメールアドレスへ配信されます。",
    InsufficientPurchase: "このアイテムを購入するのに必要なポイントがありません。あなたが現在所有しているポイント： {{current_balance}}",
    NoCreditCard: "続けるには、ポイントをご購入のうえ、製品やサービスと交換してください。",
    AddPaymentMethod: "お支払い方法を追加",
    PurchaseCredits: "ポイントを購入",
    Credits: "USD",
    ForSubscription: "{{price}} USD per year (for {{frequency}} Subscription Only)",
    YourProductFile: "あなたの製品:",
    YourPreviewFile: "Your Preview:",
    Price: "Price in USD",
    Free: "無料",
    Subscribe: "Subscribe",
    Subscribed: "Subscribed",
    frequencyOptions: {
      daily: "日刊",
      weekly: "週刊",
      monthly: "月刊",
      quarterly: "季刊",
      yearly: "年刊",
    },
  },
  profile: {
    dataPrice: {
      data: "データ",
      title: "自分の価格ページをセットアップする",
      sub: "価格ページにあなたの商品価格を載せたいですか？ あなたの製品の価格をリストアップ・更新し、カスタマーへお知らせできます！",
      set_up_now: "いますぐセットアップする",
    },
  },
  trade: {
    trade_term: {
      CFR: "CFR",
      CIF: "CIF",
      CIP: "CIP",
      CPT: "CPT",
      DAP: "DAP",
      DAF: "DAF",
      DEQ: "DEQ",
      DES: "DES",
      DDP: "DDP",
      DDU: "DDU",
      Exworks: "Exworks",
      FAS: "FAS",
      FCA: "FCA",
      FOB: "FOB",
    },
    packaging_type: {
      Drums: "ドラム",
      Bags: "バッグ",
      Flexibags: "フレキシバッグ",
      "Bulk Vessel": "在来船",
      IBC: "IBC",
      Isotank: "Iso タンク",
      Carton: "Carton",
      Pallet: "Pallet",
      "Tanker": "Tanker"
    },
    price_currency: {
      EUR: "EUR",
      GBP: "GBP",
      RMB: "RMB",
      SGD: "SGD",
      USD: "USD",
      MYR: "MYR",
      INR: "INR"
    },
    unit: {
      MT: "MT",
      lb: "lb",
      gal: "gal",
      "troy ounce": "トロイオンス",
      bbl: "bbl",
      kg: "kg",
      l: "l",
      ml: "ml",
      FCL: "FCL",
      carton: "carton",
    },
  },
  user: {
    name: "名前",
    company_name: "会社名",
  },
  channelsList: {
    tags: "タグ",
    search: "キーワード/チャンネルを検索",
    allChannels: "すべてのチャンネル",
    noChannelFound: "申し訳ございません。お探しのチャンネルは現在見つかりません。",
    noSearchResult: "検索しても見つかりませんか?",
    noSearchResultDescription: "上記カスタマーセンターへご連絡ください。Amandaがあなたの必要な情報についてお答えします!",
    loadingData: "データを読み込んでいます。お待ちください...",
    open: "開く",
    loadMore: "さらに読み込む",
  },
  email: {
    subscribe: "購読",
    lead_text: "{{channelName}}のアップデート・製品・サービスに関するニュースを購読する!",
    input_placeholder: "emailアドレスを入力して下さい",
    error_invalid_email: "このemailアドレスは無効です",
    error_already_subscribed: "このemailアドレスは既にこのチャンネルを購読しています",
    success_subscribed: "{{channelName}}のメールリストに参加しました",
    item_email_success: "このアイテムをダウンロードするために必要なURLが、あなたのEmailへ送信されました",
    header: "無料ダウンロード",
    body: '"{{productName}}" を以下のメールアドレスへ送信致します',
  },
};



// WEBPACK FOOTER //
// ./app/constants/translations/react-native/ja.ts